import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState
} from 'react';

type CollectorSyncStatusType = {
  collectorsSyncStatus: { [k: string]: string | undefined };
  setCollectorSyncStatus: (
    installId: string,
    value: string | undefined
  ) => void;
};

export const CollectorSyncStatusContext = createContext<CollectorSyncStatusType>(
  {
    collectorsSyncStatus: {},
    setCollectorSyncStatus: () => {}
  }
);

export const useCollectorSyncStatusContext = (): CollectorSyncStatusType =>
  useContext(CollectorSyncStatusContext);

const CollectorSyncStatusContextProvider: React.FC = ({
  children
}: {
  children?: React.ReactNode;
}) => {
  const [collectorsSyncStatus, setCollectorsSyncStatus] = useState({});
  const setCollectorSyncStatus = useCallback(
    (installId: string, value: string | undefined) => {
      setCollectorsSyncStatus((collectorsSyncStatus) => ({
        ...collectorsSyncStatus,
        [installId]: value
      }));
    },
    [setCollectorsSyncStatus]
  );

  const value = useMemo(() => {
    return {
      collectorsSyncStatus,
      setCollectorSyncStatus
    };
  }, [collectorsSyncStatus, setCollectorSyncStatus]);

  return (
    <CollectorSyncStatusContext.Provider value={value}>
      {children}
    </CollectorSyncStatusContext.Provider>
  );
};

export default CollectorSyncStatusContextProvider;
